// src/components/Sidebar.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar, setActiveSection } from '../redux/slices/uiSlice';
import { FaTachometerAlt, FaChartLine, FaBell, FaCog, FaChevronLeft, FaSignOutAlt, FaRobot } from 'react-icons/fa';
import { auth } from '../firebase/config';
import toast from 'react-hot-toast';
import Logo from './Logo';

const Sidebar = () => {
  const dispatch = useDispatch();
  const { sidebarCollapsed, activeSection } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <FaTachometerAlt /> },
    { id: 'trading', label: 'Trading Bot', icon: <FaRobot /> },
    { id: 'monitors', label: 'Monitors', icon: <FaChartLine /> },
    { id: 'signals', label: 'Signal History', icon: <FaBell /> },
    { id: 'settings', label: 'Settings', icon: <FaCog /> },
  ];

  const handleLogout = async () => {
    try {
      await auth.signOut();
      toast.success('Logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed');
    }
  };

  return (
    <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={() => dispatch(toggleSidebar())}>
        <FaChevronLeft />
      </div>
      <div className="logo logo-centered">
        <Logo size="sidebar" />
      </div>
      
      <div className="nav-items">
        {navItems.map(item => (
          <div
            key={item.id}
            className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
            onClick={() => dispatch(setActiveSection(item.id))}
          >
            {item.icon}
            {!sidebarCollapsed && <span>{item.label}</span>}
          </div>
        ))}
      </div>
      
      <div className="sidebar-footer">
        <div className="nav-item logout-item" onClick={handleLogout}>
          <FaSignOutAlt />
          {!sidebarCollapsed && <span>Logout</span>}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;